<h1 mat-dialog-title>{{'portal.address.modal.remove.title' | translate}}</h1>
<mat-dialog-content>
  {{'portal.address.modal.remove.body' | translate}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button [mat-dialog-close]="false">{{'portal.generic.cancel' | translate}}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">{{'portal.generic.ok' | translate}}</button>
</mat-dialog-actions>
